import { useFirestoreGeneral } from "../../firebase/useFirestore"
import { useHistory } from "react-router-dom";
import { client } from '../../hooks/Client';

const PairedToQuestionnaireMeta = ({questionnaireId}) => {

    // Hooks
      const history = useHistory()

    // Firestore
    const questionaire = useFirestoreGeneral('Questionnaires', 'ID', questionnaireId ? questionnaireId : '')
    const research = useFirestoreGeneral('Research', 'QuestionnaireID', questionnaireId ? questionnaireId : '')

  return (
    <>
    {questionaire.length > 0 ? questionaire.map((item, index) => (
        <div key={item.ID}>
            <p 
            id='indicators-paired-to-questionaire-p' 
            onClick={() => history.push(`/${client}/questionairebuilder/${questionnaireId}/${research[0].ID}`)}
            >
              {item.Title}
            </p>
        </div>
    ))
    : <p id='indicators-not-paired-to-questionaire-p-notice'>Niet gekoppeld aan vragenlijst</p>}
    </>
  )
}

export default PairedToQuestionnaireMeta